import { render, staticRenderFns } from "./SozlesmeAlacakForm.vue?vue&type=template&id=836807fe"
import script from "./SozlesmeAlacakForm.vue?vue&type=script&lang=ts"
export * from "./SozlesmeAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports